import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QuizState } from '../reducers/quizes.reducer';
import { QUIZ_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<QuizState>(QUIZ_FEATURE_KEY);

export const selectQuizId = createSelector(selectState, (state) => state.quizId);
export const selectQuiz = createSelector(selectState, (state) => state.quiz);
export const selectLoading = createSelector(selectState, (state) => state.loading);
export const selectLoaded = createSelector(selectState, (state) => state.loaded);
